import * as S from './side-nav.styled'
import { SideNavContentProps } from './side-nav.types'

export const SideNavLayout = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <S.Layout {...props} />
)

export const SideNavContent = ({ scroll, ...props }: SideNavContentProps) => (
  <S.Content $scroll={scroll} {...props} />
)
